import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/app.css";
import "../js/app.js";
import "../css/login.css"; 
import { handleSignIn } from "../Services/APIService";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    document.getElementById("UserIderror")?.classList.add("d-none");
    document.getElementById("autherror")?.classList.add("d-none");
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    document.getElementById("passworderror")?.classList.add("d-none");
    document.getElementById("autherror")?.classList.add("d-none");
  };

  const handleSignInClick = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!email) {
      document.getElementById("UserIderror")?.classList.remove("d-none");
      setErrorMsg("Enter Email");
      return;
    } else {
      document.getElementById("UserIderror")?.classList.add("d-none");
    }

    if (!password) {
      document.getElementById("passworderror")?.classList.remove("d-none");
      setErrorMsg("Enter Password");
      return;
    } else {
      document.getElementById("passworderror")?.classList.add("d-none");
    }

    setIsLoading(true);
    const result = await handleSignIn(email, password, navigate, setErrorMsg);
    setIsLoading(false);

    if (result.message === "Authentication failed.") {
      setErrorMsg(result.message);
      document.getElementById("autherror")?.classList.remove("d-none");
    }
  };

  return (
    <>
      
      <div className="login-wrapper">
        <div className="login-card">

          {/* Logo */}
          <img src="/img/Zentro_Logo.png" alt="Zentro" className="login-logo" />
          <p className="login-tagline">Sign in to your account</p>

          {/* Auth Error */}
          <p id="autherror" className="login-auth-error d-none">
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            {errorMsg}
          </p>

          <form onSubmit={handleSignInClick}>

            {/* Username */}
            <div className="login-field">
              <label className="login-label">User Name</label>
              <div className="login-input-wrap">
                <span className="login-input-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </span>
                <input
                  className="login-input"
                  type="text"
                  name="email"
                  placeholder="Enter your username"
                  value={email}
                  onChange={handleEmailChange}
                />
              </div>
              <span id="UserIderror" className="login-val-error d-none">
                Please enter your username
              </span>
            </div>

            {/* Password */}
            <div className="login-field">
              <label className="login-label">Password</label>
              <div className="login-input-wrap">
                <span className="login-input-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                </span>
                <input
                  className="login-input"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={handlePasswordChange}
                />
                <button
                  type="button"
                  className="login-eye-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  ) : (
                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
              <span id="passworderror" className="login-val-error d-none">
                Please enter your password
              </span>
            </div>

            {/* Submit */}
            <button className="login-btn" type="submit" disabled={isLoading}>
              {isLoading && <span className="login-spinner" />}
              {isLoading ? "Signing in..." : "Sign In"}
            </button>

          </form>

          {/* <div className="login-footer">
           Don&apos;t have an account?
            <a href="/pages-sign-up">Sign up</a>
          </div> */}

        </div>
      </div>
    </>
  );
};

export default LoginPage;